import React from 'react';

export const useScrollDirection = () => {
  // State to store the last scroll position
  const [lastScrollTop, setLastScrollTop] = React.useState(0);
  // State to store the direction of scroll ('up' or 'down')
  const [scrollDirection, setScrollDirection] = React.useState<'up' | 'down'>('down');
  const [scrollPositionWhenDirectionChanged, setScrollPositionWhenDirectionChanged] =
    React.useState(0);

  React.useLayoutEffect(() => {
    const handleScroll = () => {
      // Get the current scroll position
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Determine the scroll direction
      if (currentScrollTop > lastScrollTop) {
        if (scrollDirection !== 'down') {
          setScrollPositionWhenDirectionChanged(currentScrollTop);
        }
        // Scrolling down
        setScrollDirection('down');
      } else if (currentScrollTop < lastScrollTop) {
        if (scrollDirection !== 'up') {
          setScrollPositionWhenDirectionChanged(currentScrollTop);
        }
        // Scrolling up
        setScrollDirection('up');
      }

      // Update the last scroll position
      setLastScrollTop(currentScrollTop);
    };

    // Add the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollTop, scrollDirection]);

  return { scrollDirection, scrollPositionWhenDirectionChanged };
};
